export function useTenantPath() {
    const route = useRoute();
    const tenantStore = useTenantStore();
    const { getHostname, isCustomDomain } = useDomainResolver();

    type TenantPathInput = string | {
        path?: string,
        query?: Record<string, string | number | boolean | null | undefined>,
    };

    const currentTenantSlug = computed(() => {
        const routeTenantSlug = route.params.tenantSlug;
        if (typeof routeTenantSlug === 'string' && routeTenantSlug.trim()) {
            return routeTenantSlug.trim();
        }

        return String(tenantStore.currentTenantId || '').trim();
    });

    const usingCustomDomain = computed(() => {
        if (import.meta.server) return false;
        return isCustomDomain(getHostname());
    });

    function tenantPath(input: TenantPathInput = '/'): string {
        const rawPath = typeof input === 'string' ? input : (input.path || '/');
        const normalizedPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
        const query = typeof input === 'string' ? undefined : input.query;
        const queryString = query
            ? new URLSearchParams(
                Object.entries(query)
                    .filter(([, value]) => value !== undefined && value !== null && value !== '')
                    .map(([key, value]) => [key, String(value)]),
            ).toString()
            : '';
        const finalPath = queryString ? `${normalizedPath}${normalizedPath.includes('?') ? '&' : '?'}${queryString}` : normalizedPath;

        if (!currentTenantSlug.value) {
            return finalPath;
        }

        return `/${currentTenantSlug.value}${finalPath === '/' ? '' : finalPath}`;
    }

    return {
        currentTenantSlug,
        usingCustomDomain,
        tenantPath,
    };
}
